var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"floating-button",on:{"click":_vm.redirectToWhatsApp}},[_c('font-awesome-icon',{staticStyle:{"font-size":"40px"},attrs:{"icon":['fab', 'whatsapp']}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }